import fp from 'lodash/fp';
import { branch, renderNothing } from 'recompose';
import NotFound from '../pages/not-found';

const ifNoResourceData = fp.curry(
  (left, resourceName, checkLoading, dataName) =>
    branch(
      fp.flow(
        fp.get(dataName),
        ({ loading, ...data }) =>
          checkLoading ?
            !fp.has(resourceName, data) || loading :
            !fp.get(resourceName, data)
      ),
      left
    )
);

export const hideIfNoResourceData = ifNoResourceData(renderNothing);
export const notFoundIfNoResourceData = ifNoResourceData(() => NotFound);

export const hideIfNoArtistData = hideIfNoResourceData('artist', true);
export const notFoundIfNoArtistData = notFoundIfNoResourceData('artist', false);

export const hideIfNoArtistsData = hideIfNoResourceData('artists', true);

export const hideIfNoEventData = hideIfNoResourceData('event', true);
export const notFoundIfNoEventData = notFoundIfNoResourceData('event', false);



// WEBPACK FOOTER //
// ./src/components/higher-order/if-no-resource-data.js